<template>
  <div class="row">&nbsp;</div>
  <div v-if="this.user.role_name === 'system' || this.user.role_name === 'systemadmin' || this.user.role_name === 'administrator' || this.user.role_name === 'supper-vip'">
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div class="row">
            <!-- <WelcomeCard /> -->
            <div class="col-xxl-12">
              <div class="row widget-grid">
                <div class="card profile-box">
                  <div class="card-body">
                    <div class="media">
                      <div class="media-body">
                        <div class="greeting-user">
                          <h4 class="f-w-600 mb-0">
                            <vue-feather
                              type="server"
                              size="25"
                            ></vue-feather>
                            Coupon
                          </h4>
                          <p>&nbsp;</p>
                          <p>&nbsp;</p>
                        </div>
                      </div>
                    </div>
                    <div class="cartoon">
                      <img
                        class="img-fluid"
                        src="@/assets/images/dashboard/cartoon.svg"
                        alt="vector women with leptop"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-12" v-if="this.page_permission === 'Y'">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <form @submit.prevent="create_event" class="needs-validation">
                  <div class="col-sm-12">
                  <b>Coupon system: </b>&nbsp;&nbsp;
                <div class="form-check form-check-inline">
                   <input class="form-check-input" @change.prevent="update_event_coupon" v-model="is_enable_coupon_system" checked required type="radio"
                    name="inlineRadioOptions" id="inlineRadio1" value="Y">
                  <label class="form-check-label" for="inlineRadio1">
                    Enable
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" @change.prevent="update_event_coupon" v-model="is_enable_coupon_system" type="radio" required name="inlineRadioOptions"
                    id="inlineRadio2" value="N">
                  <label class="form-check-label" for="inlineRadio2">
                    Disable
                  </label>
                </div>
                </div>
              </form>
            </div>
          </div>

          
          </div>

          <div class="card" v-if="this.is_enable_coupon_system ==='Y'">
          <div class="card-body">
            <div class="row">
              <form @submit.prevent="generate_coupon" class="needs-validation">
                  <div class="col-sm-12">
                  <b>Generate Coupon </b>
                  <hr>
                    <div class="col-sm-12 col-lg-6">
                      <div class="input-group mb-3 ">
                        <span class="input-group-text" id="basic-addon1">Coupon Unit</span>
                        <input type="number" class="form-control" min="0" max="1000" v-model="coupon_discount_unit" placeholder="10"  required  >
                      </div>
                    </div>
                    <div class="col-sm-12 col-lg-6">
                      <div class="input-group mb-3 ">
                        <span class="input-group-text" id="basic-addon2">Coupon discount percent(%)</span>
                        <input type="text" class="form-control" minlength="5" maxlength="5" v-model="coupon_discount_percent" placeholder="37.4"  required  >
                      </div>
                    </div>
                    <div class="col-sm-12 col-lg-6">
                      <div class="input-group mb-3">
                        <span class="input-group-text" id="basic-addon3">Discount type</span>
                        <select disabled class="form-select" required v-model="coupon_discount_type"  id="floatingSelect">
                          <option value="PERCENTAGE">PERCENTAGE</option>
                          <option value="FIXPRICE">FIXPRICE</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-12 col-lg-6">
                      <div class="input-group mb-3">
                        <span class="input-group-text"  id="basic-addon4" >Discount prefix(if any)</span>
                        <input type="text" class="form-control" minlength="3" maxlength="3" v-model="coupon_discount_prefix" placeholder="spi"   >
                      </div>
                    </div>

                    
                    <div class="row">
                      <div class="d-flex justify-content-center">
                        <button type="submit" style="cursor: pointer"
                          class="btn btn-primary btn-lg col-6">Generate coupon</button>&nbsp;
                        <button  type="reset" @click.prevent="clear" style="cursor: pointer" class="btn btn-primary btn-lg" > Clear </button> 
                      </div>
                  </div>


                </div>
              </form>
            </div>
          </div>
          </div>

        <div class="card" v-if="this.is_enable_coupon_system ==='Y'">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <h5 class="mb-1">Coupon Table</h5>
                    <small class="text-muted coupon-summary-line">
                      ทั้งหมด {{ conpon_obj.length }} รายการ
                      <button
                        type="button"
                        class="export-mini-btn"
                        :disabled="conpon_obj.length === 0"
                        @click="exportToExcel('all')"
                      >
                        <vue-feather type="download" size="11"></vue-feather>
                      </button>
                      |
                      ใช้ไปแล้ว {{ conpon_obj.filter(item => item.unit == 0).length }} รายการ
                      <button
                        type="button"
                        class="export-mini-btn"
                        :disabled="conpon_obj.filter(item => item.unit == 0).length === 0"
                        @click="exportToExcel('used')"
                      >
                        <vue-feather type="download" size="11"></vue-feather>
                      </button>
                      |
                      คงเหลือ {{ conpon_obj.filter(item => item.unit > 0).length }} รายการ
                      <button
                        type="button"
                        class="export-mini-btn"
                        :disabled="conpon_obj.filter(item => item.unit > 0).length === 0"
                        @click="exportToExcel('unused')"
                      >
                        <vue-feather type="download" size="11"></vue-feather>
                      </button>
                    </small>
                  </div>
                </div>
                <div class="coupon-filter-tags mb-3">
                  <button
                    type="button"
                    class="coupon-filter-tag"
                    :class="{ active: coupon_filter === 'all' }"
                    @click="coupon_filter = 'all'"
                  >
                    ทั้งหมด
                  </button>
                  <button
                    type="button"
                    class="coupon-filter-tag"
                    :class="{ active: coupon_filter === 'used' }"
                    @click="coupon_filter = 'used'"
                  >
                    ใช้แล้ว
                  </button>
                  <button
                    type="button"
                    class="coupon-filter-tag"
                    :class="{ active: coupon_filter === 'unused' }"
                    @click="coupon_filter = 'unused'"
                  >
                    ยังไม่ได้ใช้
                  </button>
                </div>
            <div class="table-responsive-sm currency-table">
              <table class="table">
                <thead>
                  <tr>
                    <th class="f-light" style="text-align: center">No.</th>
                    <th class="f-light" style="text-align: center">Code</th>
                    <th class="f-light" style="text-align: center">Description</th>
                    <th class="f-light" style="text-align: center">Discount</th>
                    <th class="f-light" style="text-align: center">Unit</th>
                  </tr>
                </thead>
                <tbody v-if="this.is_loading === 'Y' &&  this.conpon_obj.length === 0" >
                  <tr>
                    <td colspan="10">
                      <div class="d-flex justify-content-center">
                        <img
                          style="align-items: center; width: 30px"
                          src="../../assets/images/running_loading.svg"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tbody v-if="filteredCoupons.length !== 0">
                  <tr v-for="(item, index) in filteredCoupons"
                      :key="item.id"
                      :class="{ 'table-danger': item.unit == 0 }">
                    <td style="text-align: center">{{ index + 1 }}</td>
                    <td style="text-align: center">{{ item.code }}</td>
                    <td style="text-align: center">{{ item.description }}</td>
                    <td style="text-align: center">{{ item.discount }}</td>
                    <td style="text-align: center">{{ item.unit }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
              </div>
              <div class="col-sm-12"><br>
              </div>
              <div class="col-sm-12">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <h5 class="mb-0">Coupon Vouchers</h5>
                  <div class="d-flex gap-2">
                    <button 
                      v-if="conpon_obj.filter(item => item.unit > 0).length > 0"
                      id="export-pdf-btn"
                      @click="exportToPDF" 
                      class="btn btn-success btn-sm"
                    >
                      <vue-feather type="download" size="14"></vue-feather>
                      Export PDF for Print
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div v-for="item in filteredVoucherCoupons" :key="item.id"  class="col-md-3 col-lg-3 mb-3">
                    <div class="voucher-card" :ref="`voucher-${item.id}`">
                      <div class="voucher-header">
                        <div class="voucher-logo-bg">
                          <img src="../../assets/images/running/running-logo-s.png" alt="Logo" class="logo-img-bg">
                        </div>
                        <div class="voucher-discount">{{ item.discount }}% OFF</div>
                        <div class="voucher-type">{{ item.description_en }}</div>
                      </div>
                      <div class="voucher-body">
                        <div class="voucher-code">{{ item.code }}</div>
                        <div class="voucher-remaining">{{ item.unit }} remaining</div>
                      </div>
                      <div class="voucher-footer">
                        <div class="facebook-follow">
                          <vue-feather type="facebook" size="14"></vue-feather>
                          Follow us Facebook: {{ systemFacebookName }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        </div>
        
         <div v-if="this.page_permission === 'N'">
          <div class="d-flex justify-content-center">this page is not authorized</div>
        </div>

      </div>
    </div>
  </div>
  <div v-if="this.user.role_name === 'photographer'">
    <div class="d-flex justify-content-center">this page is not authorized</div>
  </div>
</template>
<style scoped>
.red-row {
  background-color: #f8d7da !important;
  color: #721c24 !important;
}

.voucher-card {
  background: linear-gradient(145deg, #ff0000 00%, #ffffff 70%);
  border-radius: 15px;
  padding: 20px;
  color: rgb(0, 0, 0);
  position: relative;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
}

.voucher-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
}

.voucher-card::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 100px;
  height: 100px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  transform: translate(30px, -30px);
}

.voucher-header {
  text-align: center;
  margin-bottom: 15px;
  position: relative;
}

.voucher-logo-bg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.logo-img-bg {
  width: 80px;
  height: 80px;
  object-fit: contain;
  opacity: 0.2;
}

.voucher-discount {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px;
  position: relative;
  z-index: 2;
}

.voucher-type {
  font-size: 12px;
  opacity: 0.8;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.voucher-body {
  text-align: center;
  margin-bottom: 15px;
}

.voucher-code {
  background: rgba(255, 255, 255, 0.2);
  padding: 10px 15px;
  border-radius: 8px;
  font-family: 'Courier New', monospace;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 8px;
  border: 2px dashed rgba(255, 255, 255, 0.5);
}

.voucher-remaining {
  font-size: 12px;
  opacity: 0.8;
}

.voucher-footer {
  text-align: center;
}

.facebook-follow {
  font-size: 12px;
  opacity: 0.9;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.coupon-filter-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.coupon-filter-tag {
  border: 1px solid #d0d5dd;
  background: #ffffff;
  color: #344054;
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  transition: all 0.2s ease;
}

.coupon-filter-tag:hover {
  border-color: #0d6efd;
  color: #0d6efd;
}

.coupon-filter-tag.active {
  background: #0d6efd;
  border-color: #0d6efd;
  color: #ffffff;
}

.coupon-summary-line {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.export-mini-btn {
  width: 22px;
  height: 22px;
  border: 1px solid #d0d5dd;
  border-radius: 999px;
  background: #ffffff;
  color: #0d6efd;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
  transition: all 0.2s ease;
}

.export-mini-btn:hover:not(:disabled) {
  border-color: #0d6efd;
  background: #eef4ff;
}

.export-mini-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
</style>

<script>
import axios from "axios";
export default {
  data() {
    return {
      user: {},
      token: localStorage.getItem("jwt"),
      is_enable_coupon_system: null,
      conpon_obj: [],
      coupon_filter: 'all',

      coupon_discount_unit: null,
      coupon_discount_percent: null,
      coupon_discount_type: "PERCENTAGE",
      coupon_discount_prefix: "",
      page_permission: null,
      event_coupon_obj: {},
      systemFacebookName: process.env.VUE_APP_SYSTEM_FACEBOOK_NAME || 'Facebook',

    };
  },
  computed: {
    // systemFacebookName() {
    //   return process.env.VUE_APP_SYSTEM_FACEBOOK_NAME || 'Facebook';
    // },
    filteredCoupons() {
      if (this.coupon_filter === 'used') {
        return this.conpon_obj.filter((item) => Number(item.unit) === 0);
      }

      if (this.coupon_filter === 'unused') {
        return this.conpon_obj.filter((item) => Number(item.unit) > 0);
      }

      return this.conpon_obj;
    },
    filteredVoucherCoupons() {
      return this.coupon_filter === 'used'
        ? []
        : this.conpon_obj.filter((item) => Number(item.unit) > 0);
    },
  },
  async created(){
    this.token = localStorage.getItem("jwt")
  },
  async mounted() {
    try {
      this.user = JSON.parse(localStorage.getItem("user"));

      await this.checkpermision();
      if(this.page_permission === 'Y'){
        await this.getEventCoupon()
        this.get_coupon()
      }

    } catch (error) {
      alert("An error has occurred. Please contact the system administrator.");
    }
  },
  methods: {
    async exportToPDF() {
      try {
        // Show loading state
        const button = document.getElementById('export-pdf-btn');
        if (!button) {
          throw new Error('Export button not found');
        }
        const originalText = button.innerHTML;
        button.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Generating PDF...';
        button.disabled = true;

        // Dynamically import required libraries
        const html2canvas = await import('html2canvas');
        const { jsPDF } = await import('jspdf');

        // Create a container for all vouchers
        const printContainer = document.createElement('div');
        printContainer.style.cssText = `
          position: absolute;
          top: -9999px;
          left: -9999px;
          width: 210mm;
          padding: 5mm;
          background: white;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-content: flex-start;
          gap: 1mm;
        `;
        
        // Clone each voucher card for printing
        const activeCoupons = this.conpon_obj.filter(item => item.unit > 0);
        activeCoupons.forEach((item, index) => {
          // Create voucher for each unit available
          for (let i = 0; i < item.unit; i++) {
            const voucherDiv = document.createElement('div');
            voucherDiv.style.cssText = `
              width: 48mm;
              height: 30mm;
              margin-bottom: 1mm;
              background: linear-gradient(145deg, #ff0000 00%, #ffffff 70%);
              border-radius: 0px;
              padding: 1mm;
              color: rgb(0, 0, 0);
              position: relative;
              box-sizing: border-box;
              page-break-inside: avoid;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            `;
            
            voucherDiv.innerHTML = `
              <div style="text-align: center; position: relative; flex: 1; display: flex; flex-direction: column; justify-content: center;">
                
                <div style="position: relative; z-index: 2;">
                  <div style="font-size: 12px; font-weight: bold; margin-bottom: 1mm;">${item.discount}% OFF</div>
                  <div style="font-size: 10px; opacity: 0.9; text-transform: uppercase; letter-spacing: 0.3px; margin-bottom: 2mm;">SPECIAL PROMO CODE</div>
                  <div style="background: rgba(255, 255, 255, 0.25); padding: 1mm 2.5mm; border-radius: 2mm; font-family: 'Courier New', monospace; font-size: 15px; font-weight: bold; border: 1px dashed rgba(255, 255, 255, 0.6); margin-bottom: 1mm;">${item.code}</div>
                </div>
              </div>
              <div style="text-align: center; font-size: 10px; opacity: 0.8; margin-top: 1mm;">
                Follow us Facebook: ${this.systemFacebookName}
              </div>
            `;
            printContainer.appendChild(voucherDiv);
          }
        });

        document.body.appendChild(printContainer);

        // Generate PDF
        const canvas = await html2canvas.default(printContainer, {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          backgroundColor: '#ffffff'
        });

        const pdf = new jsPDF({
          orientation: 'portrait',
          unit: 'mm',
          format: 'a4'
        });

        const imgData = canvas.toDataURL('image/png');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        
        // Calculate how much content fits on one page
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;
        const ratio = canvasWidth / pdfWidth;
        const scaledCanvasHeight = canvasHeight / ratio;
        
        // If content is larger than one page, split it
        if (scaledCanvasHeight > pdfHeight) {
          let yPosition = 0;
          let pageCount = 0;
          
          while (yPosition < scaledCanvasHeight) {
            if (pageCount > 0) {
              pdf.addPage();
            }
            
            // Calculate the portion of canvas to add to current page
            const sourceY = yPosition * ratio;
            const sourceHeight = Math.min(pdfHeight * ratio, canvasHeight - sourceY);
            
            // Create a temporary canvas for this page portion
            const tempCanvas = document.createElement('canvas');
            tempCanvas.width = canvasWidth;
            tempCanvas.height = sourceHeight;
            const tempCtx = tempCanvas.getContext('2d');
            
            // Draw the portion of the original canvas
            tempCtx.drawImage(canvas, 0, sourceY, canvasWidth, sourceHeight, 0, 0, canvasWidth, sourceHeight);
            
            const tempImgData = tempCanvas.toDataURL('image/png');
            const tempHeight = sourceHeight / ratio;
            
            pdf.addImage(tempImgData, 'PNG', 0, 0, pdfWidth, tempHeight);
            
            yPosition += pdfHeight;
            pageCount++;
          }
        } else {
          // Content fits on one page
          pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, scaledCanvasHeight);
        }

        pdf.save('voucher-cards.pdf');

        // Clean up
        document.body.removeChild(printContainer);
        
        // Reset button
        button.innerHTML = originalText;
        button.disabled = false;

        alert('PDF exported successfully!');

      } catch (error) {
        console.error('Error exporting PDF:', error);
        alert('Error exporting PDF. Please try again.');
        
        // Reset button on error
        const button = document.getElementById('export-pdf-btn');
        if (button) {
          button.textContent = 'Export PDF for Print';
          button.disabled = false;
        }
      }
    },
    escapeHtml(value) {
      return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    },
    getExportTimestamp() {
      const now = new Date();
      const pad = (value) => String(value).padStart(2, '0');

      return [
        now.getFullYear(),
        pad(now.getMonth() + 1),
        pad(now.getDate()),
        pad(now.getHours()),
        pad(now.getMinutes()),
      ].join('');
    },
    async exportToExcel(filterType = 'all') {
      const XLSX = await import('xlsx');

      let sourceCoupons = this.conpon_obj;
      if (filterType === 'used') {
        sourceCoupons = this.conpon_obj.filter((item) => Number(item.unit) === 0);
      } else if (filterType === 'unused') {
        sourceCoupons = this.conpon_obj.filter((item) => Number(item.unit) > 0);
      }

      if (sourceCoupons.length === 0) {
        return;
      }

      const rows = sourceCoupons.map((item, index) => ({
        'No.': index + 1,
        Code: item.code,
        Description: item.description,
        Discount: item.discount,
        Unit: item.unit,
        Status: Number(item.unit) > 0 ? 'Unused' : 'Used',
      }));

      const worksheet = XLSX.utils.json_to_sheet(rows);
      worksheet['!cols'] = [
        { wch: 8 },
        { wch: 22 },
        { wch: 26 },
        { wch: 12 },
        { wch: 10 },
        { wch: 12 },
      ];

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Coupons');
      XLSX.writeFile(workbook, `coupon-export-${this.$route.params.q}-${filterType}-${this.getExportTimestamp()}.xlsx`);
    },
    async clear(){
      this.get_coupon()
    },
    async generate_coupon(){
      let data = {
        coupon_discount_unit: this.coupon_discount_unit,
        coupon_discount_percent: this.coupon_discount_percent,
        coupon_discount_type: this.coupon_discount_type,
        coupon_discount_prefix: this.coupon_discount_prefix,
        event_key: this.$route.params.q,
      };
      
      const headers = { 
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/partner/generate-coupon",data, { headers } );
      if (response.data.status === "success") {
          alert(response.data.message)
          this.get_coupon()
      } else {
        alert("Error pls contact admin!");
      }
    }, 
    async update_event_coupon(){
      let data = {
        event_key: this.$route.params.q,
        is_enable_coupon_system: this.is_enable_coupon_system
      };
      
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/partner/event-coupon",
        data,
        {
          headers
        }
      );
      if (response.data.status === "success") {
        
      } else {
        alert("An error has occurred. Please contact the system administrator.");
      }
    }, 
    async getEventCoupon(){
      let data = {
        event_key: this.$route.params.q,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/partner/event",
        data,
        {
          headers
        }
      );
      if (response.data.status === "success") {
        this.event_coupon_obj = response.data.body
        this.is_enable_coupon_system = this.event_coupon_obj[0].is_coupon
      } else {
        alert("An error has occurred. Please contact the system administrator.");
      }
    },  
    async checkpermision(){
      try {
        let data = {
          event_key: this.$route.params.q,
        };
        const headers = {
          'Authorization': 'Bearer ' + this.token
        };
        const response = await axios.post("/v1/partner/permission", data,{
          headers
        });
        if (response.data.status === "success") {
          let bodyPermission = JSON.parse(JSON.stringify(response.data.body));
          this.page_permission = bodyPermission.permission

          this.user = JSON.parse(localStorage.getItem('user'))

        if(this.page_permission ==='Y'){
            ///

        }

        }else{
          alert("permission is not recognized by admin")
        }
        } catch (error) {
        alert("login An error has occurred. Please contact the system administrator.")
        //this.$router.push({ path: "/auth/login" });
      }
    },  
    async get_coupon(){

      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      let data = {
        event_key: this.$route.params.q,
      };
      const response = await axios.post(
        "v1/utils/coupons",
        data,
        {
          headers
        }
      );
      //console.log("response::::",response)
      if (response.data.status === "success") {
        this.conpon_obj = response.data.body
      }
    },
  },
};
</script>
